import createSagaMiddleware from 'redux-saga';

import { flashMessageOnServerError } from './app/sagas/flashMessageOnServerError';
import { flashMessageOnServerSuccess } from './app/sagas/flashMessageOnServerSuccess';
import { httpError } from './app/sagas/httpError';
import { login } from './auth/sagas/login';
import { redirectOnLogin } from './auth/sagas/redirectOnLogin';
import { redirectOnLogout } from './auth/sagas/redirectOnLogout';
import { refreshOn401 } from './auth/sagas/refreshOn401';
import { fetchVisitAndUnitsAsync } from './visits/sagas/fetchVisitAndUnitsAsync';
import { storeUnit } from './visits/sagas/storeUnit';
import { storeVisit } from './visits/sagas/storeVisit';
import { deleteVisit } from './visits/sagas/deleteVisit';
import { submitVisit } from './visits/sagas/submitVisit';
import { fetchUnits } from './visits/sagas/fetchUnits';
import { fetchVisits } from './visits/sagas/fetchVisits';
import { deleteUnit } from './visits/sagas/deleteUnit';
import { verifyUnit } from './visits/sagas/verifyUnit';
import { fetchGoods } from './visits/sagas/fetchGoods';
import { storeGood } from './visits/sagas/storeGood';
import { deleteGood } from './visits/sagas/deleteGood';
import { fetchDocs } from './visits/sagas/fetchDocs';
import { storeDoc } from './visits/sagas/storeDoc';
import { deleteDoc } from './visits/sagas/deleteDoc';
import { fetchVisitOnStoreUnit } from './visits/sagas/fetchVisitOnStoreUnit';
import { fetchVisitOnDeleteUnit } from './visits/sagas/fetchVisitOnDeleteUnit';
import { fetchTimeSlots } from './visits/sagas/fetchTimeSlots';
import { redirectToEditVisitOnCreateVisit } from './visits/sagas/redirectToEditVisitOnCreateVisit';
import { redirectTo404OnVisitNotFound } from './visits/sagas/redirectTo404OnVisitNotFound';
import { redirectOnSubmit } from './visits/sagas/redirectOnSubmit';
import { clearVisitOnFormReset } from './visits/sagas/clearVisitOnFormReset';
import { setLanguageOnLogin } from './profile/sagas/setLanguageOnLogin';

/**
 * @CoreConcept(name="Redux Sagas", description="Asynchronously handle application side effects. More info: https://github.com/yelouafi/redux-saga")
 */
export const sagaMiddleware = createSagaMiddleware(
    flashMessageOnServerError, flashMessageOnServerSuccess, httpError,
    login, redirectOnLogin, redirectOnLogout, refreshOn401,
    setLanguageOnLogin,
    fetchVisitAndUnitsAsync, fetchVisitOnStoreUnit, fetchVisitOnDeleteUnit, fetchUnits, fetchVisits, storeUnit, storeVisit, deleteVisit, submitVisit, deleteUnit, verifyUnit, fetchTimeSlots, redirectToEditVisitOnCreateVisit, redirectTo404OnVisitNotFound, redirectOnSubmit,
    fetchGoods, storeGood, deleteGood, clearVisitOnFormReset,
    fetchDocs, storeDoc, deleteDoc
);
